import React from "react"
import { CreateEventAdminForm } from "../../../components/CreateEventAdminForm"

export const CreateEventAdminPage = () => {
  return (
    <div>
      <CreateEventAdminForm />
    </div>
  )
}
